import {
  Box,
  Button,
  IconButton,
  InputBase,
  Stack,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useState } from "react";
import Search from "components/Atoms/Input/Search/Search";
import { useThemePalette } from "common/hooks/theme_palette";

const Header = ({
  Title,
  isSearch,
  setFilterObj,
  createBtnTitle,
  createBtnFun,
  CreateBtnIcon,
  handlePageChange,
  searchInputPlaceholder,
  children,
}) => {
  const [value, setValue] = useState(null);
  const { primary } = useThemePalette();
  useEffect(() => {
    const timeId =
      value !== null &&
      setTimeout(() => {
        setFilterObj((data) => {
          return {
            ...data,
            keyword: value,
          };
        });
        handlePageChange(1);
      }, 500);
    return () => clearTimeout(timeId);
  }, [value]);

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      alignItems={{ xs: "flex-start", md: "center" }}
      justifyContent="space-between"
      gap={2}
      // sx={{ mt: 2 }}
    >
      <Stack width={{ xs: "100%", md: "50%" }}>
        <Typography fontSize="32px" fontWeight="700" fontFamily="Cairo">
          {Title}
        </Typography>
      </Stack>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        width={{ xs: "100%", md: "50%" }}
        gap={2}
        alignSelf={{ xs: "stretch", md: "end" }}
        justifyContent="end"
        alignItems={{ xs: "stretch", sm: "center" }}
      >
        <>
          {isSearch && (
            <Search
              placeholder={searchInputPlaceholder}
              onChange={(e) => {
                setValue(e.target.value?.trim());
              }}
              setFilterObj={setFilterObj}
            />
          )}
        </>
        {children}
        {createBtnTitle && (
          <Button
            onClick={createBtnFun}
            variant="contained"
            sx={{
              px: { xs: 4, sm: 6, md: 10 },
              py: 1.5,
              textTransform: "none",
              display: "flex",
              position: "relative",
              justifyContent: "center",
              backgroundColor: primary,
              "&:hover": {
                backgroundColor: primary,
              },
            }}
          >
            {CreateBtnIcon && (
              <CreateBtnIcon
                sx={{
                  position: "absolute",
                  left: { xs: "12px", sm: "16px", md: "20px" },
                  fontSize: { xs: "20px", sm: "24px" },
                }}
              />
            )}

            <Typography
              sx={{
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                fontFamily: "Cairo",
                fontWeight: "400",
              }}
            >
              {createBtnTitle}
            </Typography>
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default Header;

// <Stack flexDirection="row" bgcolor="white" borderRadius="10px">
// <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
//   <SearchIcon />
// </IconButton>
// <InputBase
//   sx={{ ml: 1, width: "100%" }}
//   placeholder={searchInputPlaceholder}
//   type={"text"}
//   size="small"
// onChange={(e) => {
//   setValue(e.target.value);
// }}
// />
// </Stack>
